module.exports = __webpack_public_path__ + "static/media/vf_wbag_core.bd50111a.svg";